export const meta = { id: 'O16', slug: 'organizar-sequencia', title: 'Como organizar a sequência do Treinamento', description: 'Ordene Módulos e Aulas para formar uma experiência de aprendizagem coerente.', profile: 'owner', category: 'treinamentos', type: 'task', status: 'published', order: 460, keywords: ['ordem','sequência','módulos','aulas','treinamento'], previous: 'O15', next: 'O17', related: ['O13','O14','O15'], updatedAt: '2026-08-17', appVersion: 'v1' }

# Como organizar a sequência do Treinamento

A ordem final define o percurso que o Aluno seguirá.

<HelpImage pendingId="O16.1" alt="Controles de ordenação de módulos e aulas" />

## Revise antes de disponibilizar

- os módulos estão em progressão lógica;
- as aulas aparecem na ordem esperada;
- títulos combinam com o conteúdo;
- recursos necessários estão disponíveis;
- o próximo passo do Aluno está claro.

<Callout type="important">Uma estrutura tecnicamente correta ainda pode ser pedagogicamente confusa. Revise sempre a experiência completa do Aluno.</Callout>
